export default __webpack_public_path__ + "static/media/ctoken-wbtc.4df98f46.svg";